export default __webpack_public_path__ + "static/media/G_sound.5df043e3.mp3";